import React, { Component } from "react";
import { Box, Grid } from "@mui/material";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { Check, Delete, Edit } from "@mui/icons-material";
import { fetchDetailMaster } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import Progress from "./CustomTool/Progress";
import {
  getRowData,
  isValidItem,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";

class DetailMaster extends Component {
  state = {
    Type: [
      { Type: "Sales" },
      { Type: "Purchase" },
      // { Type: "Sales Item" },
      // { Type: "Purchase Item " },
    ],
    TaxList: [],
    LedgerNameList: [],
    formData: {
      cmbType: "",
    },
    columns: [
      { id: "Action", label: "", name: "" },
      {
        id: "bint_displayorderno",
        label: "Display Order",
        type: "CtTxt",
        CtrlProps: { maxLength: 3 },
      },
      {
        id: "vac_headingvalue",
        label: "Heading",
        type: "CtTxt",
        CtrlProps: {
          maxLength: 100,
          width: 150,
        },
      },
      {
        id: "vac_controltype",
        label: "Control Type",
        type: "CtCmbEditable",
        CtrlProps: {
          maxLength: 100,
          width: 160,
          disablecondition: [
            {
              colID: "enable",
              value: false,
              relationalOperator: "===",
            },
          ],
          items: [
            { calStyle: "Text" },
            { calStyle: "Amount Only" },
            { calStyle: "List" },
          ],
          colID: "calStyle",
        },
      },
      {
        id: "vac_calculationstyle",
        label: "Calculation Style",
        type: "CtCmbEditable",

        CtrlProps: {
          maxLength: 100,
          width: 170,
          items: [
            { calStyle: " " },
            { calStyle: "Before Tax" },
            { calStyle: "After Tax" },
          ],
          colID: "calStyle",
        },
      },
      {
        id: "vac_calculation",
        label: "Calculation",
        type: "CtCmbEditable",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          items: [{ cal: " " }, { cal: "+" }, { cal: "-" }],
          colID: "cal",
          value: " ",
          disablecondition: [
            {
              colID: "enablecalculation",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      {
        id: "vac_taxname",
        label: "Tax Name",
        type: "CtCmbEditable",
        CtrlProps: {
          focus: true,
          maxLength: 100,
          width: 100,
          items: [],
          colID: "vac_taxname",
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      {
        id: "vac_hsncode",
        label: "HSN Code",
        type: "CtTxt",
        CtrlProps: {
          focus: true,
          maxLength: 100,
          width: 100,
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      {
        id: "vac_ledgername",
        label: "Ledger Name",
        type: "CtCmbEditable",
        CtrlProps: {
          maxLength: 100,
          width: 250,
          items: [],
          colID: "vac_ledgername",
          value: " ",
          disablecondition: [
            {
              colID: "enablecalculation",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      {
        id: "bint_ledgercode",
        label: "Ledger Code",
        type: "CtCmbEditable",
        CtrlProps: {
          maxLength: 100,
          width: 100,
          items: [],
          colID: "bint_ledgercode",
          value: " ",
          disablecondition: [
            {
              colID: "enablecalculation",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
    ],
    keyColumn: [
      "bint_displayorderno",
      "vac_headingvalue",
      "vac_controltype",
      "vac_calculationstyle",
      "vac_calculation",
      "vac_taxname",
      "vac_hsncode",
    ],
    actionList: [
      {
        name: "Delete",
        icon: <Delete />,
        link: "",
        actionType: "AlertResponsive",
      },
    ],
    rows: [
      {
        editdisplayorderno: 0,
        bint_displayorderno: 1,
        vac_headingvalue: "",
        vac_hsncode: "",
        enablestatus: false,
        enablecalculation: false,
        focus: false,
      },
    ],
    rowsCount: 1,
    rowsPerPage: 100,
    inputRows: [],
    dataLoadStatus: true,
    editdisplayorderno: 0,
    removeKeyboardShortCuts: null,
  };
  //#region Component
  componentDidMount() {
    document.title = "RA : Detail";
    this.ShortCut();
    this.props.setActiveMenu("DetailMaster");
    this.props.verifyUserID(
      undefined,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges,
    );
  }

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  //#endregion Component

  //#region Handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbType") {
          this.loadDetail();
        }
      },
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    let bint_displayorderno = row.bint_displayorderno,
      vac_headingvalue = row.vac_headingvalue,
      editdisplayorderno = row.editdisplayorderno,
      actionName = row.actionName;
    console.log("editdisplayorderno", editdisplayorderno);

    if (actionName === "Delete") {
      if (editdisplayorderno > 0 && this.validateDelete()) {
        return;
      }
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Detail : " + vac_headingvalue + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteDetail(bint_displayorderno, editdisplayorderno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };
  // DeleteDetailFE = (bint_displayorderno) => {
  //   let rows = this.state.rows.filter((row, index) => {
  //       if (row.bint_displayorderno != bint_displayorderno) {
  //         return row;
  //       }
  //     }),
  //     rowsCount = rows.length;
  //   this.setState({
  //     ARD: null,
  //     rows,
  //     rowsCount,
  //   });
  // };
  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    let updatedRows = rows.map((row, index) => {
      let updatedRow = { ...row };

      if (updatedRow["vac_calculationstyle"] === "Before Tax") {
        updatedRow["vac_controltype"] = "Amount Only";
        updatedRow["enable"] = false;
        updatedRow["enablestatus"] = true;
        if (this.state.formData.cmbType == "Sales") {
          if (localStorage.getItem("GSTNo").length == 0) {
            updatedRow["vac_taxname"] = "0";
            updatedRow["enablestatus"] = false;
          }
        }
        let columns = this.state.columns.map((col) => {
          if (col.id === "vac_taxname") {
            return {
              ...col,
              CtrlProps: {
                ...col.CtrlProps,
                focus: false,
              },
            };
          }
          if (col.id === "vac_hsncode") {
            return {
              ...col,
              CtrlProps: {
                ...col.CtrlProps,
                focus: false,
              },
            };
          }
          return col;
        });
        this.setState({ columns });
        updatedRow["enablecalculation"] = true;
      } else if (updatedRow["vac_calculationstyle"] === "After Tax") {
        updatedRow["vac_controltype"] = "Amount Only";
        updatedRow["enable"] = false;
        let columns = this.state.columns.map((col) => {
          if (col.id === "vac_taxname") {
            return {
              ...col,
              CtrlProps: {
                ...col.CtrlProps,
                focus: true,
              },
            };
          }
          if (col.id === "vac_hsncode") {
            return {
              ...col,
              CtrlProps: {
                ...col.CtrlProps,
                focus: true,
              },
            };
          }
          return col;
        });
        this.setState({ columns });
        updatedRow["enablestatus"] = false;
        updatedRow["enablecalculation"] = true;
        updatedRow["vac_taxname"] = "";
        updatedRow["vac_hsncode"] = "";
      } else {
        updatedRow["enable"] = true;
        // updatedRow["vac_controltype"] = "";
        updatedRow["enablestatus"] = false;
        updatedRow["enablecalculation"] = false;
        updatedRow["vac_calculation"] = "";
        updatedRow["vac_taxname"] = "";
        updatedRow["vac_hsncode"] = "";
        updatedRow["vac_ledgername"] = "";
        updatedRow["bint_ledgercode"] = "";
      }

      if (colID === "vac_ledgername") {
        const itemData = getRowData(
          this.state.LedgerNameList,
          "vac_ledgername",
          updatedRow[colID],
        );
        updatedRow["bint_ledgercode"] = itemData
          ? itemData.bint_ledgercode
          : "";
      } else if (colID === "bint_ledgercode") {
        const itemData = getRowData(
          this.state.LedgerNameList,
          "bint_ledgercode",
          updatedRow[colID],
        );
        updatedRow["vac_ledgername"] = itemData ? itemData.vac_ledgername : "";
      }
      return updatedRow;
    });

    this.setState({ rows: updatedRows, rowsCount: updatedRows.length });
  };

  handleOnNewEntryClick = () => {
    this.newRow();
  };

  //#endregion Handle

  //#region Function
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.SaveDetailMaster,
        handleOnclickNew: this.clearInfo,
      }),
    });
  };

  DeleteDetail = (bint_displayorderno, editdisplayorderno) => {
    let rows = this.state.rows.filter((row) => {
      if (row.bint_displayorderno !== bint_displayorderno) {
        return row;
      }
    });
    this.setState({ rows, ARD: null }, () => {
      if (this.state.formData.cmbType.length > 0 && editdisplayorderno > 0) {
        this.SaveDetailMaster(false);
      }
    });
  };

  newRow = (newRows, nextDisplayorderBE, returnRows) => {
    const rows = newRows !== undefined ? newRows : this.state.rows;
    let nextDisplayorder = nextDisplayorderBE
      ? nextDisplayorderBE
      : this.getNextDisplayOrder();
    rows.push({
      bint_displayorderno: nextDisplayorder,
      vac_headingvalue: "",
      enablestatus: false,
      enablecalculation: false,
      focus: true,
    });
    if (returnRows) {
      return rows;
    } else {
      this.setState({ rows, rowsCount: rows.length });
    }
  };

  validateDetailMaster = () => {
    let result = false;
    if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (this.getinputrows().length > 0) {
      result = true;
      // console.log("first", this.getinputrows.length);
    } /* else {
      this.props.toastErrorMsg("Enter atleast one detail to save.");
    } */

    return result;
  };
  validateDelete = () => {
    const inputRows = this.getinputrowsDelete();
    if (inputRows.length < 2) {
      this.props.toastErrorMsg("Enter two Item detail then Delete");
      return true;
    }
    return false;
  };
  getinputrowsDelete = () => {
    const inputRows = [];
    const { rows, LedgerNameList } = this.state;

    for (let index = 0; index < rows.length; index++) {
      const row = rows[index];
      const {
        vac_headingvalue,
        bint_displayorderno,
        vac_ledgername,
        bint_ledgercode,
        vac_calculationstyle,
        vac_taxname,
        vac_calculation,
      } = row;

      const hasHeading = vac_headingvalue && vac_headingvalue.trim() !== "";
      const displayOrderValid = Number(bint_displayorderno) > 0;
      const ledgerNameValid =
        vac_ledgername && vac_ledgername.trim().length > 0;
      const TaxNameValid = vac_taxname && vac_taxname.trim().length > 0;
      const ledgerCodeValid = Number(bint_ledgercode) > 0;
      const calculationStyleBeforeTax = vac_calculationstyle == "Before Tax";
      const calculationStyle =
        vac_calculationstyle && vac_calculationstyle.trim() !== "";

      if (!hasHeading) continue;
      if (!vac_headingvalue?.trim() || !(Number(bint_displayorderno) > 0)) {
        continue;
      }
      if (!displayOrderValid) continue;

      if (hasHeading && !calculationStyle) {
        // this.props.toastErrorMsg(
        //   `Select Calculation Style In Row ${index + 1}`
        // );
        return [];
      }

      if (calculationStyle && !vac_calculation) {
        // this.props.toastErrorMsg(`Select Calculation In Row ${index + 1}`);
        return [];
      }

      if (
        vac_calculation.length > 0 &&
        !isValidItem(
          [
            { vac_calculation: " " },
            { vac_calculation: "+" },
            { vac_calculation: "-" },
          ],
          "vac_calculation",
          vac_calculation,
        )
      ) {
        // this.props.toastErrorMsg(
        //   `Select Valid Calculation In Row ${index + 1}`
        // );
        return [];
      }

      if (calculationStyleBeforeTax && !vac_taxname) {
        // this.props.toastErrorMsg(`Select Tax Name In Row ${index + 1}`);
        return [];
      }

      if (calculationStyleBeforeTax && !vac_taxname) {
        // this.props.toastErrorMsg(`Select Tax Name In Row ${index + 1}`);
        return [];
      }

      if (
        TaxNameValid &&
        !isValidItem(this.state.TaxList, "vac_taxname", vac_taxname)
      ) {
        // this.props.toastErrorMsg(`Select Valid Tax Name In Row ${index + 1}`);
        return [];
      }

      if (!ledgerNameValid) {
        // this.props.toastErrorMsg(`Select Ledger Name In Row ${index + 1}`);
        return [];
      }

      if (!ledgerNameValid) {
        // this.props.toastErrorMsg(`Select Ledger Name In Row ${index + 1}`);
        return [];
      }

      if (
        ledgerNameValid &&
        !isValidItem(LedgerNameList, "vac_ledgername", vac_ledgername)
      ) {
        // this.props.toastErrorMsg(
        //   `Select Valid Ledger Name In Row ${index + 1}`
        // );
        return [];
      }

      if (!ledgerCodeValid) {
        // this.props.toastErrorMsg(`Select Ledger Code In Row ${index + 1}`);
        return [];
      }

      if (
        ledgerCodeValid &&
        !isValidItem(LedgerNameList, "vac_ledgername", vac_ledgername)
      ) {
        // this.props.toastErrorMsg(
        //   `Select Valid Ledger Code In Row ${index + 1}`
        // );
        return [];
      }
      // If all validations pass, push row
      inputRows.push(row);
    }

    if (inputRows.length <= 0) {
      this.props.toastErrorMsg("Enter two Item detail then Delete");
    }

    return inputRows;
  };
  getinputrows = () => {
    const inputRows = [];
    const { rows, LedgerNameList } = this.state;

    for (let index = 0; index < rows.length; index++) {
      const row = rows[index];
      const {
        vac_headingvalue,
        vac_controltype,
        bint_displayorderno,
        vac_ledgername,
        bint_ledgercode,
        vac_calculationstyle,
        vac_taxname,
        vac_calculation,
      } = row;

      const hasHeading = vac_headingvalue && vac_headingvalue.trim() !== "";
      const displayOrderValid = Number(bint_displayorderno) > 0;
      const ledgerNameValid =
        vac_ledgername && vac_ledgername.trim().length > 0;
      const TaxNameValid = vac_taxname && vac_taxname.trim().length > 0;
      const ledgerCodeValid = Number(bint_ledgercode) > 0;
      const calculationStyleBeforeTax = vac_calculationstyle == "Before Tax";
      const calculationStyle =
        vac_calculationstyle && vac_calculationstyle.trim() !== "";
      const controltype = vac_controltype && vac_controltype.trim() !== "";
      // console.log("calculationStyleBeforeTax", calculationStyleBeforeTax);

      if (!hasHeading) continue; // Skip blank heading rows
      // if (!controltype) continue;
      // Validate display order
      if (!displayOrderValid) continue;

      // if (hasHeading && !calculationStyle) {
      //   this.props.toastErrorMsg(
      //     `Select Calculation Style In Row ${index + 1}`
      //   );
      //   return [];
      // }
      if (hasHeading && !controltype) {
        this.props.toastErrorMsg(`Select controltype In Row ${index + 1}`);
        return [];
      }

      if (
        vac_calculationstyle &&
        !isValidItem(
          [
            { calStyle: " " },
            { calStyle: "Before Tax" },
            { calStyle: "After Tax" },
          ],
          "calStyle",
          vac_calculationstyle,
        )
      ) {
        this.props.toastErrorMsg(
          `Select Valid Calculation Style In Row ${index + 1}`,
        );
        return [];
      }

      if (calculationStyle && !vac_calculation) {
        this.props.toastErrorMsg(`Select Calculation In Row ${index + 1}`);
        return [];
      }

      if (
        vac_calculation.length > 0 &&
        !isValidItem(
          [
            { vac_calculation: " " },
            { vac_calculation: "+" },
            { vac_calculation: "-" },
          ],
          "vac_calculation",
          vac_calculation,
        )
      ) {
        this.props.toastErrorMsg(
          `Select Valid Calculation In Row ${index + 1}`,
        );
        return [];
      }

      if (calculationStyleBeforeTax && !vac_taxname) {
        this.props.toastErrorMsg(`Select Tax Name In Row ${index + 1}`);
        return [];
      }

      if (calculationStyleBeforeTax && !vac_taxname) {
        this.props.toastErrorMsg(`Select Tax Name In Row ${index + 1}`);
        return [];
      }

      if (
        TaxNameValid &&
        !isValidItem(this.state.TaxList, "vac_taxname", vac_taxname)
      ) {
        this.props.toastErrorMsg(`Select Valid Tax Name In Row ${index + 1}`);
        return [];
      }

      if (calculationStyle && !ledgerNameValid) {
        this.props.toastErrorMsg(`Select Ledger Name In Row ${index + 1}`);
        return [];
      }

      // if (calculationStyle && !ledgerNameValid) {
      //   this.props.toastErrorMsg(`Select Ledger Name In Row ${index + 1}`);
      //   return [];
      // }

      if (
        ledgerNameValid &&
        !isValidItem(LedgerNameList, "vac_ledgername", vac_ledgername)
      ) {
        this.props.toastErrorMsg(
          `Select Valid Ledger Name In Row ${index + 1}`,
        );
        return [];
      }

      if (calculationStyle && !ledgerCodeValid) {
        this.props.toastErrorMsg(`Select Ledger Code In Row ${index + 1}`);
        return [];
      }

      if (
        ledgerCodeValid &&
        !isValidItem(LedgerNameList, "vac_ledgername", vac_ledgername)
      ) {
        this.props.toastErrorMsg(
          `Select Valid Ledger Code In Row ${index + 1}`,
        );
        return [];
      }
      // If all validations pass, push row
      inputRows.push(row);
    }

    if (inputRows.length <= 0) {
      this.props.toastErrorMsg("Enter atleast one detail to save.");
    }

    return inputRows;
  };

  SaveDetailMaster = (needToValidate = true) => {
    // console.log("needToValidate:", needToValidate, ":");
    if (needToValidate === false || this.validateDetailMaster()) {
      // console.log("inif");
      const inputRowList = this.getinputrows();
      // console.log("inputRowList", inputRowList);
      this.props.notifyProcessing();
      const reqData = {
        Op: "SaveDetail",
        bint_acid: localStorage.getItem("acid"),
        vac_detailtype: this.state.formData.cmbType,
        detail: inputRowList.map((row) => {
          return {
            bint_displayorderno: row.bint_displayorderno,
            vac_headingvalue: row.vac_headingvalue,
            vac_controltype: row.vac_controltype,
            vac_calculationstyle: row.vac_calculationstyle
              ? row.vac_calculationstyle
              : "",
            vac_calculation: row.vac_calculation ? row.vac_calculation : "",
            vac_taxname: row.vac_taxname ? row.vac_taxname : "",
            vac_hsncode: row.vac_hsncode ? row.vac_hsncode : "",
            bint_ledgercode: row.bint_ledgercode ? row.bint_ledgercode : 0,
            vac_ledgername: row.vac_ledgername ? row.vac_ledgername : "",
            vac_groupname: row.bint_ledgercode
              ? getRowData(
                  this.state.LedgerNameList,
                  "bint_ledgercode",
                  row.bint_ledgercode,
                ).vac_groupname
              : "",
          };
        }),
      };
      fetchDetailMaster(reqData)
        .then((res) => {
          // console.log(res .data);
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.loadDetail();
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in SaveSupplier.", error);
        });
    }
  };

  loadDetail = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DetailList",
        bint_acid: localStorage.getItem("acid"),
        vac_detailtype: this.state.formData.cmbType,
      };
      fetchDetailMaster(reqData)
        .then((res) => {
          // console.log("res", res);
          dataLoadStatus = true;
          let maxbintdisplayorderno = res.data.max_bint_displayorderno;

          let rows = res.data.DetailList.map((row) => {
            return {
              ...row,
              editdisplayorderno: row.bint_displayorderno,
              enablestatus:
                row["vac_calculationstyle"] == "Before Tax" ? true : false,
              enablecalculation:
                row["vac_calculationstyle"] == "Before Tax" ||
                row["vac_calculationstyle"] == "After Tax"
                  ? true
                  : false,
              enable:
                row["vac_calculationstyle"] == "Before Tax" ||
                row["vac_calculationstyle"] == "After Tax"
                  ? false
                  : true,
            };
          });

          // console.log("rows in be call", rows);
          let TaxList = res.data.TaxList;
          let LedgerNameList = res.data.LedgerNameList;
          rows = this.newRow(rows, maxbintdisplayorderno, true);
          let rowsCount = rows.length;
          this.setState(
            {
              dataLoadStatus,
              rowsCount,
              rows,
              maxbintdisplayorderno,
              TaxList,
              LedgerNameList,
            },
            () => {
              this.setTaxCmb();
            },
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
  };

  setTaxCmb = () => {
    let columns = this.state.columns.map((col) => {
      if (col.id === "vac_taxname") {
        col.CtrlProps.items = this.state.TaxList;
      } else if (col.id === "vac_ledgername") {
        col.CtrlProps.items = this.state.LedgerNameList;
      } else if (col.id === "bint_ledgercode") {
        // console.log("before col.CtrlProps.items", col.CtrlProps.items);
        // console.log("this.state.LedgerNameList", this.state.LedgerNameList);
        col.CtrlProps.items = this.state.LedgerNameList;
        // col.CtrlProps.items = this.state.LedgerNameList;
        // console.log("after col.CtrlProps.items", col.CtrlProps.items);
      }
      return col;
    });
    // console.log("columns", columns);
    this.setState({ columns }, () => {});
  };

  getNextDisplayOrder = () => {
    let bint_displayorderno = 0;
    this.state.rows.map((row) => {
      if (Number(bint_displayorderno) < Number(row.bint_displayorderno)) {
        bint_displayorderno = Number(row.bint_displayorderno);
      }
    });
    bint_displayorderno++;
    return bint_displayorderno;
  };
  //#endregion

  render() {
    // console.log(
    //   "Group Name",
    //   getRowData(
    //     this.state.LedgerNameList,
    //     "bint_ledgercode",
    //     row.bint_ledgercode ? row.bint_ledgercode : 0
    //   )
    // );
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Detail</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbType"
                  label="Type"
                  items={this.state.Type}
                  value={this.state.formData.cmbType}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  colID="Type"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  id="btnSave"
                  label="Save"
                  onClick={this.SaveDetailMaster}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          // counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          // handleOnSearchChange={this.handleOnSearchChange}
          // searchColumns={this.state.searchColumns}
          // searchData={this.state.searchData}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Get New Heading Row"
          handleOnRowDataChange={this.handleOnRowDataChange}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(DetailMaster)));
